import { api } from '../../commonApi';
import { ICreateMenuItemRequest, IGetMenuItemResponse } from '../../../proto/menu/item/menuItem';

const BASE_MENU_ITEM_URL = `menuItem`;

export const menuApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getMenuItemById: builder.query<IGetMenuItemResponse, string>({
			query: (id) => `${BASE_MENU_ITEM_URL}/${id}`,
			providesTags: (res, _, id) => [{ type: 'MenuItem', id }],
		}),
		deleteMenuItem: builder.mutation<void, string>({
			query: (id) => ({
				url: `${BASE_MENU_ITEM_URL}/${id}`,
				method: 'DELETE',
			}),
		}),
		createMenuItem: builder.mutation<IGetMenuItemResponse, ICreateMenuItemRequest & { menuId: string }>({
			query: (body) => ({
				url: `${BASE_MENU_ITEM_URL}`,
				method: 'POST',
				body,
			}),
			invalidatesTags: ({ id }, err, { categoryId, menuId }) => [
				{ type: 'MenuItem', id },
				{ type: 'MenuCategory', id: categoryId },
				{ type: 'Menus', id: menuId },
			],
		}),
		updateMenuItem: builder.mutation<IGetMenuItemResponse, ICreateMenuItemRequest & { menuItemId: string; menuId: string }>({
			query: ({ menuItemId, ...body }) => ({
				url: `${BASE_MENU_ITEM_URL}/${menuItemId}`,
				method: 'PUT',
				body,
			}),
			invalidatesTags: (result, err, { categoryId, menuItemId, menuId }) => [
				{ type: 'MenuItem', id: menuItemId },
				{ type: 'MenuCategory', id: categoryId },
				{ type: 'Menus', id: menuId },
			],
		}),
	}),
});

export const { useGetMenuItemByIdQuery, useDeleteMenuItemMutation, useCreateMenuItemMutation, useUpdateMenuItemMutation } = menuApi;
